import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { rejectedExtensionQueryCol } from '../../Table/TableQueryColumn';

const initialState = {
    data: {
        runId: '',
        seqNo: '',
        carrier: '',
        accountInput: '',
        groupInput: '',
        memberInput: '',
        gpiInput: '',
        totalCount: 0,
        sortOrder: 'asc',
        columnName: 'Run Date',
        pageSize: 50,
        page: 0,
        tableData: []
    },
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: true,
    inputError: {
        accountInput: false,
        groupInput: false,
        memberInput: false,
        gpiInput: false,
    }
}


// export const getRejExtensionsTableData = createAsyncThunk('data/getRejExtensionsTableData', async (rejectedExtensionData) => {
//     let rejectedExtensionQuery = `query{

//         GetRejectedExtensionDetails(runid:"${rejectedExtensionData.runId}",seq:"${rejectedExtensionData.seqNo}",pageSize:${rejectedExtensionData.pgsize},pageNumber:${rejectedExtensionData.page + 1}${rejectedExtensionData.accountInput ? `,account: "${rejectedExtensionData.accountInput}"` : ""
//         }${rejectedExtensionData.groupInput ? `,group: "${rejectedExtensionData.groupInput}"` : ""}${rejectedExtensionData.memberInput ? `,member: "${rejectedExtensionData.memberInput}"` : ""
//         }${rejectedExtensionData.gpiInput ? `,gpi: "${rejectedExtensionData.gpiInput}"` : ""} sortOrder:"${rejectedExtensionData.sortOrder}", columnName:"${rejectedExtensionData.columnName}"`;

//     if (rejectedExtensionData.carrier !== null || rejectedExtensionData.carrier !== '') {
//         if (rejectedExtensionData.carrier.length > 0)
//             rejectedExtensionQuery += `,carrier:"${rejectedExtensionData.carrier}"`;
//     }

//     rejectedExtensionQuery += rejectedExtensionQueryCol
//     const response = await axiosInstance.post(process.env.REACT_APP_REJECTEDEXTENSION_DETAIL,
//         JSON.stringify({ query: rejectedExtensionQuery, variables: {} })
//     );
//     return JSON.stringify(response);
// });

export const getRejExtensionsTableData = createAsyncThunk('data/getRejExtensionsTableData',
    async (rejectedExtensionData, { rejectWithValue }) => {
        try {
            let rejectedExtensionQuery = `query{

               GetRejectedExtensionDetails(runid:"${rejectedExtensionData.runId}",seq:"${rejectedExtensionData.seqNo}",pageSize:${rejectedExtensionData.pageSize},pageNumber:${rejectedExtensionData.page + 1}${rejectedExtensionData.accountInput ? `,account: "${rejectedExtensionData.accountInput}"` : ""
                }${rejectedExtensionData.groupInput ? `,group: "${rejectedExtensionData.groupInput}"` : ""}${rejectedExtensionData.memberInput ? `,member: "${rejectedExtensionData.memberInput}"` : ""
                }${rejectedExtensionData.gpiInput ? `,gpi: "${rejectedExtensionData.gpiInput}"` : ""} sortOrder:"${rejectedExtensionData.sortOrder}", columnName:"${rejectedExtensionData.columnName}"`;

            if (rejectedExtensionData.carrier !== null || rejectedExtensionData.carrier !== '') {
                if (rejectedExtensionData.carrier.length > 0)
                    rejectedExtensionQuery += `,carrier:"${rejectedExtensionData.carrier}"`;
            }

            rejectedExtensionQuery += rejectedExtensionQueryCol
            const response = await axiosInstance.post(process.env.REACT_APP_REJECTEDEXTENSION_DETAIL,
                JSON.stringify({ query: rejectedExtensionQuery, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const cnsRejectedExtensions = createSlice({
    name: 'cnsRejectedExtensions',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRejExtensionsTableData.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getRejExtensionsTableData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetRejectedExtensionDetails.totalCount;
                state.data.tableData = response.data.data.GetRejectedExtensionDetails.data;
            })
            .addCase(getRejExtensionsTableData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }

})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster } = cnsRejectedExtensions.actions;
export default cnsRejectedExtensions.reducer;